import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[wsScrollTracker]',
  standalone: false,
})
export class TrackScrollingDirective {
  @Output() scrollEnded = new EventEmitter<boolean>();

  @HostListener('scroll', ['$event'])
  onScroll(event: Event) {
    const tracker = event.target as HTMLElement;
    if (!tracker) return;

    let end = false;
    const limit = tracker.scrollHeight - tracker.clientHeight;

    if (tracker.scrollTop === limit) {
      end = true;
    }

    this.scrollEnded.emit(end);
  }
}
